export default "__VITE_ASSET__a8606d67__"